import api from '../../api.js';

export const NAVIGATION_CLASS = api.core.ns('nav');
export const NAVIGATION_LIST_CLASS = api.core.ns('nav__list');
export const NAVIGATION_ITEM_CLASS = api.core.ns('nav__item');
export const NAVIGATION_ITEM_RIGHT_CLASS = api.core.ns('nav__item--align-right');
export const NAVIGATION_MENU_CLASS = api.core.ns('menu');
